<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <div class="mt-4"/>
    <RegisterList v-if="this.tag !== 'U1'" data="{tag='K6'}"/>
    <RegisterUsers v-if="this.tag == 'U1'" data="{tag='K6'}"/>
    <AppNavigationBottom/>
  </div>
</template>
<script>
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import RegisterList from "@/data/register/components/RegisterList";
import RegisterUsers from "@/data/register/components/RegisterUsers";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
// import Search from "@/data/search/components/Search";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";
import pageAccess from "@/frame/control/mixins/pageAccess.js";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    RegisterList,
    RegisterUsers
    // Search
  },
  computed: {
    ...mapGetters([
      "getSearchResults",
      "getCurrentPage",
      "getPreviousPage",
      "getPageTitle",
      "getRegisterInfo"
    ]),
    tag() {
      let tag = null;
      if (this.getSearchResults !== null && this.getSearchResults.length > 0) {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    ver() {
      let ver = null;
      if (this.getSearchResults !== null && this.getSearchResults.length > 0) {
        ver = this.getSearchResults[0].basic.ver;
      }
      return ver;
    },
    AppNavigationTopInfo() {
      let obj = {
        title: "TO BE DEFINED",
        titleColour: "wplblue0--text",
        btns: [
          {
            title: "person",
            icon: "person",
            link: "/userdash"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      if (this.ver === "A") {
        obj.title = "Archived Documents";
        if (this.tag === "O1" || this.tag === "W1" || this.tag === "W2") {
          obj.btns[0].title = "facility";
          obj.btns[0].link = "/facilitydash";
          obj.btns[0].icon = "place";
        } else {
          obj.btns[0].title = "company";
          obj.btns[0].link = "/companydash";
          obj.btns[0].icon = "account_balance";
        }
      } else if (this.tag === "A1") {
        obj.title = "Asset Register";
        obj.btns[0].title = "Facility";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "place";
      } else if (this.tag === "F1") {
        obj.title = "Facility Register";
      } else if (this.tag === "C1") {
        obj.title = "Company Register";
      } else if (this.tag === "U1") {
        obj.title = "User Register";
        obj.btns[0].icon = "apps";
        obj.btns[0].title = "main";
        obj.btns[0].link = this.getPreviousPage;
      } else if (this.tag === "O1") {
        obj.title = "Ops Notifications";
        obj.btns[0].title = "facility";
        obj.btns[0].icon = "apps";
        if (this.getPreviousPage !== "/opsdetail") {
          obj.btns[0].link = this.getPreviousPage;
        } else {
          obj.btns[0].link = "/facilitydash";
        }
      } else if (this.tag === "B1") {
        obj.title = "Risk Regiser";
        obj.btns[0].title = "Safety";
        obj.btns[0].link = "/companydashsafety";
        obj.btns[0].icon = "health_and_safety";
      } else if (this.tag === "B4") {
        obj.title = "Company Budget";
        obj.btns[0].title = "Business";
        obj.btns[0].link = "/companydashbusiness";
        obj.btns[0].icon = "analytics";
      } else if (this.tag === "B6") {
        if (
          this.getRegisterInfo !== null &&
          this.getRegisterInfo.tag === "F1"
        ) {
          obj.title = "Facility Plans";
          obj.btns[0].title = "Maintenance";
          obj.btns[0].link = "/facilitydashmaintenance";
          obj.btns[0].icon = "build";
        } else {
          obj.title = "Company Plans";
          obj.btns[0].title = "Business";
          obj.btns[0].link = "/companydashbusiness";
          obj.btns[0].icon = "apps";
        }
      } else if (this.tag === "B3") {
        if (
          this.getRegisterInfo !== null &&
          this.getRegisterInfo.tag === "F1"
        ) {
          obj.title = "Facility Actions";
          obj.btns[0].title = "Operations";
          obj.btns[0].link = "/facilitydashoperations";
          obj.btns[0].icon = "apps";
        } else if (
          this.getRegisterInfo !== null &&
          this.getRegisterInfo.tag === "U1"
        ) {
          obj.title = "User Actions";
          obj.btns[0].title = "person";
          obj.btns[0].link = "/userdash";
          obj.btns[0].icon = "apps";
        } else {
          obj.title = "Company Actions";
          obj.btns[0].title = "Business";
          obj.btns[0].link = "/companydashbusiness";
          obj.btns[0].icon = "apps";
        }
      } else if (this.tag === "U1.B3") {
        obj.title = "User Actions";
        obj.btns[0].title = "User";
        obj.btns[0].link = "/userdash";
        obj.btns[0].icon = "person";
      } else if (this.tag === "Q1") {
        obj.title = this.getPageTitle;
        obj.btns[0].title = "Business";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "analytics";
      } else if (this.tag === "L1.Q1") {
        obj.title = "Material Orders";
        obj.btns[0].title = "Business";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "analytics";
      } else if (this.tag === "B4.Q1") {
        obj.title = "Budget Orders";
        obj.btns[0].title = "Business";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "analytics";
      } else if (this.tag === "B6.W") {
        obj.title = "Plan Work Orders";
        obj.btns[0].title = "Business";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "analytics";
      } else if (this.tag === "W3") {
        obj.title = "Resource Plans";
      } else if (this.tag === "B6.W1") {
        obj.title = "Plan Work Request";
        obj.btns[0].title = "User";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "person";
      } else if (this.tag === "W3") {
        obj.title = "Resource Plans";
      } else if (this.tag === "W6") {
        obj.title = "Procedures";
        obj.btns[0].title = "Technical";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "build_circle";
      } else if (this.tag === "E6") {
        obj.title = "Results Templates";
        obj.btns[0].title = "Technical";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "build_circle";
      } else if (this.tag === "E8") {
        obj.title = "Facility Results";
        obj.btns[0].title = "Technical";
        obj.btns[0].icon = "build_circle";
        if (this.getPreviousPage !== "/reportdetail") {
          obj.btns[0].link = this.getPreviousPage;
        } else {
          obj.btns[0].link = "/facilitydashengineering";
        }
      } else if (this.tag === "M1") {
        obj.title = "Maintenance Assurance";
      } else if (this.tag === "M2") {
        obj.title = "Maintenance Strategy";
        obj.btns[0].title = "Technical";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "build_circle";
      } else if (this.tag === "M2.M5") {
        obj.title = "Startegy Maint Plans";
        obj.btns[0].title = "Business";
        obj.btns[0].link = this.getPreviousPage;
        obj.btns[0].icon = "analytics";
      } else if (this.tag === "M5") {
        obj.title = "Maintenance Plan";
        obj.btns[1].title = "Maint";
        obj.btns[1].link = this.getPreviousPage;
        obj.btns[1].icon = "build";
      } else if (this.tag === "M7") {
        obj.title = "Maintenance Call";
        obj.btns[0].title = "Tech";
        obj.btns[0].link = "/companydashtechnical";
        obj.btns[0].icon = "settings";
        obj.btns[1].title = "Maint";
        obj.btns[1].link = "/facilitydashmaintenance";
        obj.btns[1].icon = "build";
      } else if (this.tag === "W1" || this.tag === "W2") {
        obj.title = "Facility Work";
        obj.btns[0].title = "Tech";
        obj.btns[0].link = "/facilitydashengineering";
        obj.btns[0].icon = "settings";
        obj.btns[1].title = "Maint";
        obj.btns[1].link = "/facilitydashmaintenance";
        obj.btns[1].icon = "build";
      } else if (this.tag === "W2") {
        obj.title = "Maintenance Plan";
        obj.btns[0].title = "Tech";
        obj.btns[0].link = "/comapnydashtechnical";
        obj.btns[0].icon = "settings";
        obj.btns[1].title = "Maint";
        obj.btns[1].link = "/facilitydashmaintenance";
        obj.btns[1].icon = "build";
      } else if (this.tag === "E2") {
        obj.title = "Engineering Assessments";
        if (
          this.getRegisterInfo !== null &&
          this.getRegisterInfo.tag === "F1"
        ) {
          obj.btns[0].title = "Technical";
          obj.btns[0].link = "/facilitydashengineering";
          obj.btns[0].icon = "apps";
        } else {
          obj.btns[0].title = "Technical";
          obj.btns[0].link = "/companydashtechnical";
          obj.btns[0].icon = "apps";
        }
      } else if (this.tag === "E1") {
        obj.title = "Equipment Register";
        obj.btns[0].title = "Technical";
        obj.btns[0].link = "/companydashtechnical";
        obj.btns[0].icon = "build_circle";
      } else if (this.tag === "L1") {
        obj.title = "Materials Register";
        obj.btns[0].title = "Technical";
        obj.btns[0].link = "/companydashtechnical";
        obj.btns[0].icon = "build_circle";
      } else if (this.tag === "L2") {
        obj.title = "BOM Regiser";
      } else if (this.tag === "S1") {
        obj.title = "Hazard Regiser";
        obj.btns[0].title = "Safety";
        obj.btns[0].link = "/companydashsafety";
        obj.btns[0].icon = "health_and_safety";
      } else if (this.tag === "S6") {
        if (
          this.getRegisterInfo !== null &&
          this.getRegisterInfo.tag === "F1"
        ) {
          obj.title = "Facility Events and Incidents";
          obj.btns[0].title = "Operations";
          obj.btns[0].link = "/facilitydashoperations";
          obj.btns[0].icon = "apps";
        } else {
          obj.title = "All Events and Incidents";
          obj.btns[0].title = "Safety";
          obj.btns[0].link = "/companydashsafety";
          obj.btns[0].icon = "health_and_safety";
        }
      }
      return obj;
    }
  },
  mixins: [currentPage, apptheme, storeFunctions, pageAccess],
  data() {
    return {
      currentPagePath: "/registerlist"
    };
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
    this.$store.dispatch("changeTreeMasterInfo", null);
    this.$store.dispatch("changeTreeParentInfo", null);
    this.$store.dispatch("changeCommsDialog", false);
    // Reset STORE (previous document data)
    // this.resetStoreDetail();
  },
  mounted() {
    // POssible race condiction with other logic
    this.resetStoreDetail();
  }
};
</script>
